<template>
  <div v-if="isVisible" class="loading-screen">
    <div class="spinner"></div>
    <div class="loading-text">Loading the Portex Data Lab...</div>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  data() {
    return {
      isVisible: true
    }
  },
  mounted() {
 
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((entryList) => {
        for (const entry of entryList.getEntries()) {
          if (entry.name === 'first-contentful-paint') {
            this.isVisible = false;
            observer.disconnect();
          }
        }
      });
      observer.observe({ type: 'paint', buffered: true });
    }
    
    setTimeout(() => {
      this.isVisible = false;
    }, 3000);
  }
}
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 4px solid #ffffff;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-text {
  color: #ffffff;
  font-family: 'Urbanist', sans-serif;
  font-size: 18px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 